module.exports = __webpack_public_path__ + "static/media/TokenContract.6a3b59f2.png";